import { render, staticRenderFns } from "./SearchComunicacoes.vue?vue&type=template&id=765e21cc&"
import script from "./SearchComunicacoes.vue?vue&type=script&lang=js&"
export * from "./SearchComunicacoes.vue?vue&type=script&lang=js&"
import style0 from "./SearchComunicacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports